import React, { useState, Component } from 'react';
import { SearchIcon, FilterIcon, GlobeIcon, MapPinIcon, CalendarIcon, ClockIcon, ArrowUpIcon, ArrowDownIcon, ArrowUpDownIcon, InfoIcon, XIcon, ActivityIcon, BarChart2Icon, FileTextIcon, LineChartIcon, PieChartIcon, UserIcon, MailIcon, PhoneIcon, TagIcon, UserCheckIcon, EyeIcon, CheckCircleIcon, XCircleIcon, ThumbsUpIcon, ThumbsDownIcon, RefreshCwIcon, ArrowRightIcon, ChevronRightIcon, MousePointerIcon, ExternalLinkIcon, CheckIcon, UserPlusIcon, PencilIcon, StarIcon, HelpCircleIcon, ClipboardIcon, TimerIcon, ThermometerIcon, SnowflakeIcon, BanIcon, UsersIcon, TrendingUpIcon, TrendingDownIcon, PercentIcon, SlackIcon, SlashIcon, SlidersIcon, UserMinusIcon, BriefcaseIcon, TargetIcon, FilterXIcon, ChevronDownIcon, CheckSquareIcon, CalendarRangeIcon, ChevronUpIcon } from 'lucide-react';
import { DashboardCard } from './DashboardCard';
// Función para formatear fechas
const formatDate = dateString => {
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };
  return new Date(dateString).toLocaleDateString('es-ES', options);
};
// Componente para mostrar la puntuación de lead con color según el valor
function LeadScoreBadge({
  score
}) {
  let color;
  if (score >= 80) {
    color = 'bg-green-500/20 text-green-400';
  } else if (score >= 60) {
    color = 'bg-blue-500/20 text-blue-400';
  } else if (score >= 40) {
    color = 'bg-amber-500/20 text-amber-400';
  } else {
    color = 'bg-red-500/20 text-red-400';
  }
  return <div className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${color}`} data-id="element-1304" data-mp="3eml0u8m3sgia">
      <PieChartIcon size={12} className="mr-1" data-id="element-1305" data-mp="39ni73kbkpwpm" />
      {score}
    </div>;
}
export function LeadInsightsOverview() {
  return <div className="space-y-6" data-id="element-1306" data-mp="35ng1x16mql5l">
      <PublicUsersSection data-id="element-1307" data-mp="35kbqpjuqyp5f" />
    </div>;
}
function PublicUsersSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [selectedActivity, setSelectedActivity] = useState('all');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [showScoreInfo, setShowScoreInfo] = useState(null);
  // Añadir estado para filtrar por estado de calificación
  const [selectedLeadStatus, setSelectedLeadStatus] = useState('all');
  // Add sort state
  const [sortField, setSortField] = useState('score');
  const [sortDirection, setSortDirection] = useState('desc');
  // Nuevos estados para filtros adicionales
  const [scoreRange, setScoreRange] = useState([0, 100]);
  const [selectedCountry, setSelectedCountry] = useState('all');
  const [dateRange, setDateRange] = useState({
    start: null,
    end: null
  });
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  // Mock data for public users - convertido a useState para poder modificarlo
  const [publicUsers, setPublicUsers] = useState([{
    id: 1,
    name: 'Carlos Mendoza',
    email: 'cmendoza@agritech-solutions.com',
    phone: '+52 555 1234 5678',
    company: 'AgriTech Solutions',
    country: 'Mexico',
    region: 'LATAM',
    registrationDate: '2025-06-10',
    lastActive: '2025-07-15',
    designs: 12,
    quotes: 3,
    score: 87,
    scoreComponents: {
      engagement: 92,
      activity: 85,
      designQuality: 88,
      quoteRequests: 75,
      marketPotential: 95
    },
    status: 'active',
    usageFrequency: 'High',
    usageDays: [true, false, true, true, false, false, true],
    usageStats: {
      lastWeek: 5,
      lastMonth: 18,
      total: 42
    },
    tags: ['High Potential', 'Irrigation'],
    leadStatus: 'new',
    notes: 'Shows consistent interest in pivot irrigation systems'
  }, {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sjohnson@farmequip.co.nz',
    phone: '+64 21 987 6543',
    company: 'Farm Equipment Solutions',
    country: 'New Zealand',
    region: 'ANZ',
    registrationDate: '2025-05-22',
    lastActive: '2025-07-14',
    designs: 8,
    quotes: 2,
    score: 74,
    scoreComponents: {
      engagement: 70,
      activity: 75,
      designQuality: 78,
      quoteRequests: 65,
      marketPotential: 80
    },
    status: 'active',
    usageFrequency: 'Medium',
    usageDays: [true, true, false, true, true, false, false],
    usageStats: {
      lastWeek: 3,
      lastMonth: 12,
      total: 28
    },
    tags: ['Medium Potential'],
    leadStatus: 'new',
    notes: 'Interested in linear systems'
  }, {
    id: 3,
    name: 'Ahmed Al-Farsi',
    email: 'ahmed@desert-irrigation.ae',
    phone: '+971 50 123 4567',
    company: 'Desert Irrigation Technologies',
    country: 'United Arab Emirates',
    region: 'MENA',
    registrationDate: '2025-07-01',
    lastActive: '2025-07-16',
    designs: 15,
    quotes: 5,
    score: 92,
    scoreComponents: {
      engagement: 95,
      activity: 90,
      designQuality: 92,
      quoteRequests: 88,
      marketPotential: 98
    },
    status: 'active',
    usageFrequency: 'Very High',
    usageDays: [true, true, true, true, true, true, false],
    usageStats: {
      lastWeek: 6,
      lastMonth: 24,
      total: 35
    },
    tags: ['High Potential', 'VIP'],
    leadStatus: 'qualified',
    notes: 'Looking for comprehensive irrigation solutions for large farms'
  }, {
    id: 4,
    name: 'João Silva',
    email: 'jsilva@agro-brasil.com.br',
    phone: '+55 11 98765 4321',
    company: 'Agro Brasil Equipamentos',
    country: 'Brazil',
    region: 'LATAM',
    registrationDate: '2025-06-15',
    lastActive: '2025-07-10',
    designs: 5,
    quotes: 1,
    score: 65,
    scoreComponents: {
      engagement: 60,
      activity: 65,
      designQuality: 70,
      quoteRequests: 55,
      marketPotential: 75
    },
    status: 'active',
    usageFrequency: 'Medium',
    usageDays: [false, true, false, true, true, false, false],
    usageStats: {
      lastWeek: 2,
      lastMonth: 8,
      total: 15
    },
    tags: ['Medium Potential'],
    leadStatus: 'new',
    notes: 'Primarily interested in corner systems'
  }, {
    id: 5,
    name: 'Marie Dupont',
    email: 'mdupont@agri-solutions.fr',
    phone: '+33 6 12 34 56 78',
    company: 'Agri-Solutions France',
    country: 'France',
    region: 'EUROPE',
    registrationDate: '2025-05-05',
    lastActive: '2025-06-20',
    designs: 3,
    quotes: 0,
    score: 42,
    scoreComponents: {
      engagement: 40,
      activity: 35,
      designQuality: 50,
      quoteRequests: 25,
      marketPotential: 60
    },
    status: 'inactive',
    usageFrequency: 'Low',
    usageDays: [true, false, false, false, true, false, false],
    usageStats: {
      lastWeek: 0,
      lastMonth: 2,
      total: 8
    },
    tags: ['Low Potential'],
    leadStatus: 'disqualified',
    notes: 'Limited engagement, no recent activity'
  }]);
  // Datos para paneles de resumen
  const summaryData = {
    totalUsers: publicUsers.length,
    activeUsers: publicUsers.filter(user => user.status === 'active').length,
    newUsersThisMonth: 3,
    leadsByStatus: {
      hot: publicUsers.filter(user => user.leadStatus === 'qualified').length,
      warm: publicUsers.filter(user => user.leadStatus === 'new').length,
      cold: publicUsers.filter(user => user.leadStatus === 'disqualified').length,
      unclassified: publicUsers.filter(user => user.leadStatus === 'unclassified').length
    },
    averageScore: Math.round(publicUsers.reduce((acc, user) => acc + user.score, 0) / publicUsers.length),
    conversionRate: 24,
    topRegion: 'LATAM',
    growthRate: 12 // Simulado (porcentaje)
  };
  // Lista de países únicos para el filtro
  const uniqueCountries = [...new Set(publicUsers.map(user => user.country))];
  const handleViewDetails = user => {
    setSelectedUser(user);
    setShowUserDetails(true);
  };
  const handleCloseDetails = () => {
    setShowUserDetails(false);
    setSelectedUser(null);
  };
  // Tooltip state
  const [tooltipVisible, setTooltipVisible] = useState(null);
  // Actualizar la función para manejar la calificación/descalificación de leads
  const handleQualifyLead = status => {
    // Actualizar el estado del lead en el array de usuarios
    const updatedUsers = publicUsers.map(user => {
      if (user.id === selectedUser.id) {
        return {
          ...user,
          leadStatus: status
        };
      }
      return user;
    });
    setPublicUsers(updatedUsers);
    // Actualizar el usuario seleccionado para reflejar el cambio en el modal
    setSelectedUser({
      ...selectedUser,
      leadStatus: status
    });
    // Mostrar mensaje de confirmación
    const statusMessages = {
      qualified: 'Lead qualified as Hot (ready to purchase)',
      disqualified: 'Lead qualified as Cold (low activity or intention)',
      new: 'Lead qualified as Warm (interested, needs follow-up)',
      unclassified: 'Lead unclassified (no classification)'
    };
    // En una aplicación real, aquí enviaríamos los datos al servidor
    console.log(`Lead ${selectedUser.id} marked as ${status}: ${statusMessages[status]}`);
  };
  const toggleScoreInfo = userId => {
    if (showScoreInfo === userId) {
      setShowScoreInfo(null);
    } else {
      setShowScoreInfo(userId);
    }
  };
  // Add sort handler
  const handleSort = field => {
    if (sortField === field) {
      // If already sorting by this field, toggle direction
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // If sorting by a new field, default to descending
      setSortField(field);
      setSortDirection('desc');
    }
  };
  // Manejador para reset de filtros
  const handleResetFilters = () => {
    setSearchQuery('');
    setSelectedRegion('all');
    setSelectedActivity('all');
    setSelectedLeadStatus('all');
    setSelectedCountry('all');
    setScoreRange([0, 100]);
    setDateRange({
      start: null,
      end: null
    });
  };
  // Filter users based on search and filters
  const filteredUsers = publicUsers.filter(user => {
    const matchesSearch = searchQuery === '' || user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase()) || user.company.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesRegion = selectedRegion === 'all' || user.region === selectedRegion;
    const matchesActivity = selectedActivity === 'all' || selectedActivity === 'active' && user.status === 'active' || selectedActivity === 'inactive' && user.status === 'inactive';
    // Filtrar por estado de calificación
    const matchesLeadStatus = selectedLeadStatus === 'all' || user.leadStatus === selectedLeadStatus;
    // Filtrar por país
    const matchesCountry = selectedCountry === 'all' || user.country === selectedCountry;
    // Filtrar por rango de puntuación
    const matchesScoreRange = user.score >= scoreRange[0] && user.score <= scoreRange[1];
    // Filtrar por rango de fechas
    let matchesDateRange = true;
    if (dateRange.start && dateRange.end) {
      const userDate = new Date(user.registrationDate);
      const startDate = new Date(dateRange.start);
      const endDate = new Date(dateRange.end);
      matchesDateRange = userDate >= startDate && userDate <= endDate;
    }
    return matchesSearch && matchesRegion && matchesActivity && matchesLeadStatus && matchesCountry && matchesScoreRange && matchesDateRange;
  });
  // Sort filtered users
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    if (sortField === 'score') {
      return sortDirection === 'asc' ? a.score - b.score : b.score - a.score;
    } else if (sortField === 'name') {
      return sortDirection === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
    } else if (sortField === 'registrationDate') {
      const dateA = new Date(a.registrationDate);
      const dateB = new Date(b.registrationDate);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'lastActive') {
      const dateA = new Date(a.lastActive);
      const dateB = new Date(b.lastActive);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'designs') {
      return sortDirection === 'asc' ? a.designs - b.designs : b.designs - a.designs;
    }
    return 0;
  });
  // Añadir estado para controlar qué descripción larga se muestra
  const [showLongDescription, setShowLongDescription] = useState(null);
  // Función para renderizar el indicador de estado del lead con la nueva escala
  const renderLeadStatusBadge = status => {
    switch (status) {
      case 'qualified':
        return <span className="bg-red-500/20 text-red-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`hot-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1308" data-mp="4kqyygvzzkzm">
            <div size={12} className="mr-1" data-id="element-1309" data-mp="1yy8qeezix1zx" />
            Hot lead
            {tooltipVisible === `hot-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1310" data-mp="1u1i9jpfwa2dg">
                Ready to purchase
              </div>}
          </span>;
      case 'disqualified':
        return <span className="bg-blue-500/20 text-blue-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`cold-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1311" data-mp="2b9rmlfdulkn1">
            <SnowflakeIcon size={12} className="mr-1" data-id="element-1312" data-mp="1iln9i8sy65ab" />
            Cold lead
            {tooltipVisible === `cold-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1313" data-mp="1nkq7xaef9d9b">
                Low activity or intention
              </div>}
          </span>;
      case 'new':
        return <span className="bg-amber-500/20 text-amber-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`warm-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1314" data-mp="33yq4cbe26krt">
            <ThermometerIcon size={12} className="mr-1" data-id="element-1315" data-mp="36jo1xocplyw0" />
            Warm lead
            {tooltipVisible === `warm-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1316" data-mp="31l339td3vn9o">
                Interested, needs follow-up
              </div>}
          </span>;
      case 'unclassified':
        return <span className="bg-slate-500/20 text-slate-400 text-xs px-2 py-0.5 rounded-full flex items-center relative" onMouseEnter={() => setTooltipVisible(`unclassified-${status}`)} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1317" data-mp="3pgfivr4s41ww">
            <BanIcon size={12} className="mr-1" data-id="element-1318" data-mp="314klgvkkdfz" />
            Unclassified
            {tooltipVisible === `unclassified-${status}` && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1319" data-mp="3uajtckd96s2q">
                Lead with no assigned classification
              </div>}
          </span>;
      default:
        return <span className="bg-slate-500/20 text-slate-400 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-1320" data-mp="qpt48jw4uatj">
            <BanIcon size={12} className="mr-1" data-id="element-1321" data-mp="vm9zrz5nvrgn" />
            Unclassified
          </span>;
    }
  };
  // Función para mostrar/ocultar la descripción larga
  const toggleLongDescription = id => {
    if (showLongDescription === id) {
      setShowLongDescription(null);
    } else {
      setShowLongDescription(id);
    }
  };
  return <>
      {/* Paneles de resumen */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6" data-id="element-1322" data-mp="cqa3wd9kc3rs">
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1323" data-mp="3v4armj8dsixn">
          <div className="flex justify-between items-start mb-4" data-id="element-1324" data-mp="308eni5h4fba">
            <div className="p-2 rounded-lg bg-blue-500/20" data-id="element-1325" data-mp="3l51wvo5oz0a8">
              <UsersIcon size={20} className="text-blue-400" data-id="element-1326" data-mp="3l7o5zs88dnuk" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-green-500/20 text-green-400" data-id="element-1327" data-mp="3q3mx3nky1jyo">
              <ArrowUpIcon size={12} className="mr-1" data-id="element-1328" data-mp="1qxhnkl8wy1n2" />
              {summaryData.growthRate}%
            </div>
          </div>
          <div className="flex justify-between items-end" data-id="element-1329" data-mp="1mvcsrj6qayyu">
            <div data-id="element-1330" data-mp="1mti9saf0pgxe">
              <div className="text-sm text-slate-400 mb-1" data-id="element-1331" data-mp="1hx1mfifn76ld">Public Users</div>
              <div className="text-2xl font-bold text-white" data-id="element-1332" data-mp="1huoxumfdpxzc">
                {summaryData.totalUsers}
              </div>
              <div className="text-xs text-blue-400 mt-1" data-id="element-1333" data-mp="2alqfcu6jo5m1">
                {summaryData.activeUsers} active
              </div>
            </div>
            <div className="text-right" data-id="element-1334" data-mp="25l2smkpcmaxm">
              <div className="text-xs text-slate-400 mb-1" data-id="element-1335" data-mp="20n9l9ocb7avr">New this month</div>
              <div className="text-lg font-semibold text-blue-400" data-id="element-1336" data-mp="20pdmtzmqjxsv">
                +{summaryData.newUsersThisMonth}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1337" data-mp="p6jart0urwwc">
          <div className="flex justify-between items-start mb-4" data-id="element-1338" data-mp="f2clopg8sqza">
            <div className="p-2 rounded-lg bg-amber-500/20" data-id="element-1339" data-mp="k41wq53gt4nd">
              <TargetIcon size={20} className="text-amber-400" data-id="element-1340" data-mp="p1tqz5rl12uq" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-blue-500/20 text-blue-400" data-id="element-1341" data-mp="tt3f21xhfy4i">
              <PercentIcon size={12} className="mr-1" data-id="element-1342" data-mp="xv6sgw3ppcsf" />
              {summaryData.conversionRate}%
            </div>
          </div>
          <div className="mb-3" data-id="element-1343" data-mp="12s6xr4sqmbih">
            <div className="text-sm text-slate-400 mb-1" data-id="element-1344" data-mp="12vl38lwp70u5">
              Lead Qualification
            </div>
            <div className="text-2xl font-bold text-white" data-id="element-1345" data-mp="1crxrh49h4mhi">
              Average: {summaryData.averageScore}
            </div>
          </div>
          <div className="grid grid-cols-4 gap-1 text-center text-xs" data-id="element-1346" data-mp="39l9br3ydamzz">
            <div data-id="element-1347" data-mp="3eisqs62w33sz">
              <div className="bg-red-500/20 text-red-400 rounded-md py-1" data-id="element-1348" data-mp="3ekc9e3c0pqxx">
                Hot
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1349" data-mp="1ka5o8olbfqmq">
                {summaryData.leadsByStatus.hot}
              </div>
            </div>
            <div data-id="element-1350" data-mp="1u1a4drmq9hj5">
              <div className="bg-amber-500/20 text-amber-400 rounded-md py-1" data-id="element-1351" data-mp="1u1rx4ea6ldmb">
                Warm
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1352" data-mp="1p38d4jf5ebwl">
                {summaryData.leadsByStatus.warm}
              </div>
            </div>
            <div data-id="element-1353" data-mp="11efn13l7iy9w">
              <div className="bg-blue-500/20 text-blue-400 rounded-md py-1" data-id="element-1354" data-mp="wdrlhnzcqz1f">
                Cold
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1355" data-mp="1adj82d3xpnr1">
                {summaryData.leadsByStatus.cold}
              </div>
            </div>
            <div data-id="element-1356" data-mp="16ae92kj2c475">
              <div className="bg-slate-500/20 text-slate-400 rounded-md py-1" data-id="element-1357" data-mp="16e1xx6dkc2fj">
                N/C
              </div>
              <div className="text-white font-medium mt-1" data-id="element-1358" data-mp="2hr4ei1fnwrzp">
                {summaryData.leadsByStatus.unclassified || 0}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1359" data-mp="2u9gmaw9n7ynr">
          <div className="flex justify-between items-start mb-4" data-id="element-1360" data-mp="2fczbc65d8m1q">
            <div className="p-2 rounded-lg bg-purple-500/20" data-id="element-1361" data-mp="2kbakeenu6siw">
              <FileTextIcon size={20} className="text-purple-400" data-id="element-1362" data-mp="2kbso1wctw90u" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-green-500/20 text-green-400" data-id="element-1363" data-mp="38267wzl9f1kc">
              <TrendingUpIcon size={12} className="mr-1" data-id="element-1364" data-mp="3cz6dl9e762ax" />
              +12%
            </div>
          </div>
          <div className="mb-3" data-id="element-1365" data-mp="2y8z59mhwlzny">
            <div className="text-sm text-slate-400 mb-1" data-id="element-1366" data-mp="339muq3qhi8g2">Quote Requests</div>
            <div className="text-2xl font-bold text-white" data-id="element-1367" data-mp="337sc4w2oqsf5">14 this month</div>
          </div>
          <div className="space-y-2" data-id="element-1368" data-mp="3qxwc8tgo0a1e">
            <div data-id="element-1369" data-mp="3vqpg7f4b7ecf">
              <div className="flex justify-between text-xs mb-1" data-id="element-1370" data-mp="3vr7mz5ollayl">
                <span className="text-slate-400" data-id="element-1371" data-mp="1r5mcgb3k57fn">Conversion rate</span>
                <span className="text-white" data-id="element-1372" data-mp="1r8ias0jbhy4m">32%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1373" data-mp="1w4pfjpzz93kz">
                <div className="bg-purple-500 h-1.5 rounded-full" style={{
                width: '32%'
              }} data-id="element-1374" data-mp="1hfb9orvm14ac"></div>
              </div>
            </div>
            <div data-id="element-1375" data-mp="18fo8a62vryha">
              <div className="flex justify-between text-xs mb-1" data-id="element-1376" data-mp="18f4vf3s380a4">
                <span className="text-slate-400" data-id="element-1377" data-mp="18i0w2zvbl329">Response time</span>
                <span className="text-white" data-id="element-1378" data-mp="1cit63vc0nbzl">1.2 days</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1379" data-mp="yiie2oyyzrcu">
                <div className="bg-indigo-500 h-1.5 rounded-full" style={{
                width: '65%'
              }} data-id="element-1380" data-mp="13g1r5ljxly37"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-slate-800 to-blue-900/70 rounded-xl p-5 border border-blue-800/30 shadow-lg" data-id="element-1381" data-mp="2xucflswm6q8g">
          <div className="flex justify-between items-start mb-4" data-id="element-1382" data-mp="m8amfqlx0khw">
            <div className="p-2 rounded-lg bg-indigo-500/20" data-id="element-1383" data-mp="h861nodz53lv">
              <GlobeIcon size={20} className="text-indigo-400" data-id="element-1384" data-mp="h9zddi3g2e0q" />
            </div>
            <div className="flex items-center text-xs font-medium px-2 py-1 rounded-full bg-indigo-500/20 text-indigo-400" data-id="element-1385" data-mp="vxu5oxdjigda">
              <MapPinIcon size={12} className="mr-1" data-id="element-1386" data-mp="r4946vcqn49c" />
              {summaryData.topRegion}
            </div>
          </div>
          <div className="mb-3" data-id="element-1387" data-mp="zynr9k3ifj30">
            <div className="text-sm text-slate-400 mb-1" data-id="element-1388" data-mp="zxm78q4inm95">
              Regional Distribution
            </div>
            <div className="text-2xl font-bold text-white" data-id="element-1389" data-mp="1eulo74l9crga">
              5 Active Regions
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-1390" data-mp="19uqvcvhx9rsl">
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1391" data-mp="3gob57q6ayfhh">
              <div className="text-slate-400" data-id="element-1392" data-mp="3bo6nxxxklgq7">LATAM</div>
              <div className="text-white font-medium" data-id="element-1393" data-mp="3bprgji0bqplf">2 users</div>
            </div>
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1394" data-mp="57zlol0qw94c">
              <div className="text-slate-400" data-id="element-1395" data-mp="989u04c0fbmd">EUROPE</div>
              <div className="text-white font-medium" data-id="element-1396" data-mp="98tcpn9hi41g">1 user</div>
            </div>
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1397" data-mp="e6uwkaeqi7dz">
              <div className="text-slate-400" data-id="element-1398" data-mp="j6fx2p9jynst">MENA</div>
              <div className="text-white font-medium" data-id="element-1399" data-mp="j80quco1m2pm">1 user</div>
            </div>
            <div className="bg-slate-800/70 rounded-lg p-2" data-id="element-1400" data-mp="o50smbdv0jax">
              <div className="text-slate-400" data-id="element-1401" data-mp="s6vv3j7j12qa">ANZ</div>
              <div className="text-white font-medium" data-id="element-1402" data-mp="s5kuttdaid3x">1 user</div>
            </div>
          </div>
        </div>
      </div>
      <DashboardCard data-id="element-1403" data-mp="11x7bw6cb76el">
        <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-1404" data-mp="11xqgymgv20b7">
          <h3 className="text-xl font-bold text-white mb-4 md:mb-0" data-id="element-1405" data-mp="11z1pezl93w8n">
            Public Users
          </h3>
          <div className="flex flex-wrap gap-3" data-id="element-1406" data-mp="1bvegrqtbpy08">
            <div className="relative" data-id="element-1407" data-mp="1bvwj956kx8gl">
              <input type="text" placeholder="Search users..." className="pl-9 pr-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-64" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1408" data-mp="2wdfgyfs6yh5q" />
              <SearchIcon className="absolute left-3 top-2.5 text-slate-400" size={16} data-id="element-1409" data-mp="2mhc68lj9xa76" />
            </div>
            {/* Filtros básicos siempre visibles */}
            <select className="appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedLeadStatus} onChange={e => setSelectedLeadStatus(e.target.value)} data-id="element-1410" data-mp="3f2vjf8nfsjos">
              <option value="all" data-id="element-1411" data-mp="30f0t1ywwirev">All Lead Status</option>
              <option value="new" data-id="element-1412" data-mp="30ehfsvi74r76">Warm Leads</option>
              <option value="qualified" data-id="element-1413" data-mp="1pk3pv4w47cx">Hot Leads</option>
              <option value="disqualified" data-id="element-1414" data-mp="1r3jlkmmwge6">Cold Leads</option>
              <option value="unclassified" data-id="element-1415" data-mp="3t2n2vowq2sa6">Unclassified</option>
            </select>
            <button className="p-2 rounded-lg bg-slate-800 border border-slate-700 text-slate-300 hover:bg-slate-700 flex items-center" onClick={() => setShowAdvancedFilters(!showAdvancedFilters)} data-id="element-1416" data-mp="3dl58n74kncq7">
              <SlidersIcon size={18} className="mr-1" data-id="element-1417" data-mp="33o0pzh9xpze5" />
              Filters
              {showAdvancedFilters ? <ChevronUpIcon size={14} className="ml-1" data-id="element-1418" data-mp="38lsdlz3jqzcj" /> : <ChevronDownIcon size={14} className="ml-1" data-id="element-1419" data-mp="38mtyevad707g" />}
            </button>
            {filteredUsers.length !== publicUsers.length && <button className="p-2 rounded-lg bg-red-800/30 border border-red-700/30 text-red-300 hover:bg-red-800/50 flex items-center" onClick={handleResetFilters} data-id="element-1420" data-mp="55vaga3syrnp">
                <FilterXIcon size={18} className="mr-1" data-id="element-1421" data-mp="3mm37zc42ew2g" />
                Clear
              </button>}
          </div>
        </div>
        {/* Filtros avanzados (desplegables) */}
        {showAdvancedFilters && <div className="mb-6 p-4 bg-slate-800/50 rounded-lg border border-slate-700" data-id="element-1422" data-mp="j3jlkq82ikfk">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1423" data-mp="nxntpct2kyi8">
              <div data-id="element-1424" data-mp="28lqaamhws9yx">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1425" data-mp="28l74g45j9c19">
                  Region
                </label>
                <select className="w-full appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} data-id="element-1426" data-mp="23lko3luerfo8">
                  <option value="all" data-id="element-1427" data-mp="1poywutp1sp2s">All regions</option>
                  <option value="EUROPE" data-id="element-1428" data-mp="1kot0x1bqwgew">Europe</option>
                  <option value="AMERICA" data-id="element-1429" data-mp="1kqduooq8jvbp">America</option>
                  <option value="LATAM" data-id="element-1430" data-mp="1yp3re3957szj">LATAM</option>
                  <option value="MENA" data-id="element-1431" data-mp="1ypwxr346wgh5">MENA</option>
                  <option value="ANZ" data-id="element-1432" data-mp="1umqwk9vxpfhj">ANZ</option>
                  <option value="AFRICA" data-id="element-1433" data-mp="1up3c6ge7zdrf">Africa</option>
                </select>
              </div>
              <div data-id="element-1434" data-mp="3a5u1vykln6yy">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1435" data-mp="3625rz98hvzaj">
                  Country
                </label>
                <select className="w-full appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedCountry} onChange={e => setSelectedCountry(e.target.value)} data-id="element-1436" data-mp="22rro3wuph3ek">
                  <option value="all" data-id="element-1437" data-mp="2cnl984mhq57y">All countries</option>
                  {uniqueCountries.map(country => <option key={country} value={country} data-id="element-1438" data-mp="2gowzmcd6uuh7">
                      {country}
                    </option>)}
                </select>
              </div>
              <div data-id="element-1439" data-mp="1p0mvhepr9bdq">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1440" data-mp="1p03d5ww70kz6">
                  Activity status
                </label>
                <select className="w-full appearance-none bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedActivity} onChange={e => setSelectedActivity(e.target.value)} data-id="element-1441" data-mp="1xs59pk355h46">
                  <option value="all" data-id="element-1442" data-mp="15a1cs34e1mpk">All</option>
                  <option value="active" data-id="element-1443" data-mp="xsv2rkixcthw">Active</option>
                  <option value="inactive" data-id="element-1444" data-mp="xrjwne20b9nm">Inactive</option>
                </select>
              </div>
              <div data-id="element-1445" data-mp="sr5ozx4bi1q4">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1446" data-mp="orn3p08l3omr">
                  Score range
                </label>
                <div className="flex items-center space-x-2" data-id="element-1447" data-mp="jt3l99t78uz5">
                  <input type="number" min="0" max="100" value={scoreRange[0]} onChange={e => setScoreRange([parseInt(e.target.value), scoreRange[1]])} className="w-20 bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1448" data-mp="juwp6hcfh13g" />
                  <span className="text-slate-400" data-id="element-1449" data-mp="51be3l3k6n8i">to</span>
                  <input type="number" min="0" max="100" value={scoreRange[1]} onChange={e => setScoreRange([scoreRange[0], parseInt(e.target.value)])} className="w-20 bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1450" data-mp="13do4g1yrx42" />
                </div>
              </div>
              <div data-id="element-1451" data-mp="1eyi05fn4d9ru">
                <label className="block text-sm text-slate-400 mb-2" data-id="element-1452" data-mp="1jzfdnex6pfn0">
                  Registration date
                </label>
                <div className="flex items-center space-x-2" data-id="element-1453" data-mp="15yuughncxhsz">
                  <div className="relative flex-1" data-id="element-1454" data-mp="1ayzak6kcsaio">
                    <input type="date" value={dateRange.start || ''} onChange={e => setDateRange({
                  ...dateRange,
                  start: e.target.value
                })} className="w-full bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1455" data-mp="1axocmndl9wzh" />
                    <CalendarIcon size={16} className="absolute right-3 top-3 text-slate-400 pointer-events-none" data-id="element-1456" data-mp="n7lk665rip0c" />
                  </div>
                  <span className="text-slate-400" data-id="element-1457" data-mp="daz0hkp6a3zw">to</span>
                  <div className="relative flex-1" data-id="element-1458" data-mp="ddl9zpvmitkr">
                    <input type="date" value={dateRange.end || ''} onChange={e => setDateRange({
                  ...dateRange,
                  end: e.target.value
                })} className="w-full bg-slate-800 border border-slate-700 text-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1459" data-mp="i90j64ios1au" />
                    <CalendarIcon size={16} className="absolute right-3 top-3 text-slate-400 pointer-events-none" data-id="element-1460" data-mp="8kmvgiyai8pb" />
                  </div>
                </div>
              </div>
              <div className="flex items-end" data-id="element-1461" data-mp="hltfh205e1nb">
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={() => {}} data-id="element-1462" data-mp="coksmo4219fq">
                  Apply filters
                </button>
              </div>
            </div>
          </div>}
        <div className="overflow-x-auto" data-id="element-1463" data-mp="mffkc802l18k">
          <table className="w-full" data-id="element-1464" data-mp="10dvnjoyq49ly">
            <thead data-id="element-1465" data-mp="10exc8w8nwum5">
              <tr className="text-left border-b border-slate-700" data-id="element-1466" data-mp="10ef4p3gjutyx">
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('name')} data-id="element-1467" data-mp="wd3diti120om">
                  <div className="flex items-center" data-id="element-1468" data-mp="1xqgzo5okta73">
                    User
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-1469" data-mp="1ssxmza7j15h9">
                      {sortField === 'name' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1470" data-mp="1jr7v639qg4iy" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1471" data-mp="1jqfyep4eg0r3" /> : <ArrowUpDownIcon size={14} data-id="element-1472" data-mp="1erux0mdevb12" />}
                    </button>
                  </div>
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm" data-id="element-1473" data-mp="1a14pb2hiiw37">
                  Location
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('lastActive')} data-id="element-1474" data-mp="153368hk36wrq">
                  <div className="flex items-center" data-id="element-1475" data-mp="101dx57gfct6a">
                    Activity
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-1476" data-mp="w3pxxs7p8e8l">
                      {sortField === 'lastActive' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1477" data-mp="32ouctt0iea2x" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1478" data-mp="32s8cgthsg56o" /> : <ArrowUpDownIcon size={14} data-id="element-1479" data-mp="37nnqblfsq133" />}
                    </button>
                  </div>
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('designs')} data-id="element-1480" data-mp="3brda7xlizuhs">
                  <div className="flex items-center" data-id="element-1481" data-mp="2jzo14py4uiqm">
                    Designs
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-1482" data-mp="2jxl2jhiwzhaa">
                      {sortField === 'designs' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1483" data-mp="2szat6l4z2c70" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1484" data-mp="2xqsw3eqk2mum" /> : <ArrowUpDownIcon size={14} data-id="element-1485" data-mp="2xsdmcs5u7jmo" />}
                    </button>
                  </div>
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm cursor-pointer group" onClick={() => handleSort('score')} data-id="element-1486" data-mp="209c7mzpzkx73">
                  <div className="flex items-center" data-id="element-1487" data-mp="38kvxlr2xki3m">
                    Score
                    <button className="ml-1 text-slate-400 group-hover:text-blue-400 transition-colors" title="Sort by score" data-id="element-1488" data-mp="33mcbnqoc76b9">
                      {sortField === 'score' ? sortDirection === 'asc' ? <ArrowUpIcon size={14} className="text-blue-400" data-id="element-1489" data-mp="3hftsv4tjw6y4" /> : <ArrowDownIcon size={14} className="text-blue-400" data-id="element-1490" data-mp="3dbvuiwc1v064" /> : <ArrowUpDownIcon size={14} data-id="element-1491" data-mp="3dei1atr49bna" />}
                    </button>
                    <button className="ml-1 text-slate-400 hover:text-blue-400 transition-colors" title="What is Lead Score?" onClick={e => {
                    e.stopPropagation();
                    toggleScoreInfo('info');
                  }} data-id="element-1492" data-mp="2pmtdnqp8pbco">
                      <InfoIcon size={14} data-id="element-1493" data-mp="2tnn2cmaiau6m" />
                    </button>
                  </div>
                  {showScoreInfo === 'info' && <div className="absolute z-10 mt-2 bg-slate-800 border border-slate-700 rounded-lg shadow-xl p-4 w-80 left-1/2 transform -translate-x-1/2" data-id="element-1494" data-mp="dvpgl6m6p0jp">
                      <div className="flex justify-between items-start mb-2" data-id="element-1495" data-mp="hf6eaea02cz6">
                        <h4 className="text-white font-medium" data-id="element-1496" data-mp="hhasbp1m4sd6">
                          Lead Scoring System
                        </h4>
                        <button className="text-slate-400 hover:text-white" onClick={() => setShowScoreInfo(null)} data-id="element-1497" data-mp="7hjwnk1bg7bi">
                          <XIcon size={14} data-id="element-1498" data-mp="cgmqs9frct4p" />
                        </button>
                      </div>
                      <div className="space-y-3" data-id="element-1499" data-mp="106qsucdasktl">
                        <p className="text-slate-300 text-sm" data-id="element-1500" data-mp="154itpvvx7h9x">
                          The lead score (0-100) evaluates the conversion
                          potential and commercial value of each user based on
                          multiple factors:
                        </p>
                        <div className="space-y-2 mt-2" data-id="element-1501" data-mp="vccv43b5y1lr">
                          <div className="flex items-start" data-id="element-1502" data-mp="1j3ibcjl0mvwl">
                            <ActivityIcon size={14} className="mt-0.5 mr-2 text-blue-400 flex-shrink-0" data-id="element-1503" data-mp="1nuqmbk1zupbv" />
                            <div data-id="element-1504" data-mp="3vf39remaol9h">
                              <div className="text-sm font-medium text-white" data-id="element-1505" data-mp="3vg4wigcoaw71">
                                Platform Activity (25%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1506" data-mp="3md3qsgrpz73w">
                                Login frequency, session time, interactions with
                                key tools
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1507" data-mp="dxk3dydqciwr">
                            <MapPinIcon size={14} className="mt-0.5 mr-2 text-emerald-400 flex-shrink-0" data-id="element-1508" data-mp="e0fyzg23uvi1" />
                            <div data-id="element-1509" data-mp="48a7s8jogi3w">
                              <div className="text-sm font-medium text-white" data-id="element-1510" data-mp="4923rkh6shup">
                                Geographic Location (15%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1511" data-mp="wx7q2bnw2ewn">
                                Market potential in the region, distributor
                                presence
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1512" data-mp="1990aau3p6umt">
                            <FileTextIcon size={14} className="mt-0.5 mr-2 text-amber-400 flex-shrink-0" data-id="element-1513" data-mp="1e4p4ehwy7jbq" />
                            <div data-id="element-1514" data-mp="1j6o8ju0iik9q">
                              <div className="text-sm font-medium text-white" data-id="element-1515" data-mp="1n6ycl14qv0ly">
                                Quote Requests (20%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1516" data-mp="1s48dbcxl2yp3">
                                Number and frequency of requested quotes
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1517" data-mp="26vh8e1k99c9m">
                            <BriefcaseIcon size={14} className="mt-0.5 mr-2 text-indigo-400 flex-shrink-0" data-id="element-1518" data-mp="26suqb7zqned5" />
                            <div data-id="element-1519" data-mp="2au6hvj26a9nz">
                              <div className="text-sm font-medium text-white" data-id="element-1520" data-mp="br9cekfw2iva">
                                Professional Profile (15%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1521" data-mp="kk2zh41kumjp">
                                Company type, sector, estimated size
                              </div>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-1522" data-mp="uh7nzaiwau3o">
                            <BarChart2Icon size={14} className="mt-0.5 mr-2 text-purple-400 flex-shrink-0" data-id="element-1523" data-mp="pj61efm9gcng" />
                            <div data-id="element-1524" data-mp="13ip2wpkkgpqs">
                              <div className="text-sm font-medium text-white" data-id="element-1525" data-mp="13hnpieg2vr5w">
                                Design Complexity (25%)
                              </div>
                              <div className="text-xs text-slate-400" data-id="element-1526" data-mp="359scdbipzy9r">
                                Project sophistication, size and technical
                                specifications
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pt-2 border-t border-slate-700" data-id="element-1527" data-mp="2v5bzmr0jexa6">
                          <div className="flex items-center justify-between" data-id="element-1528" data-mp="2hfia06h7k8ze">
                            <div className="text-sm text-blue-300" data-id="element-1529" data-mp="2me38a0cwgil7">
                              Automatic classification:
                            </div>
                          </div>
                          <div className="grid grid-cols-3 gap-2 mt-2 text-xs text-center" data-id="element-1530" data-mp="27j5er460ln2j">
                            <div className="bg-red-500/20 text-red-400 rounded p-1" data-id="element-1531" data-mp="2cdsy6om5vra9">
                              Hot (80-100)
                            </div>
                            <div className="bg-amber-500/20 text-amber-400 rounded p-1" data-id="element-1532" data-mp="23g0ez9dbjzhl">
                              Warm (60-79)
                            </div>
                            <div className="bg-blue-500/20 text-blue-400 rounded p-1" data-id="element-1533" data-mp="1nkomrwsshd0">
                              Cold (0-59)
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm" data-id="element-1534" data-mp="10i89nm0xxct7">
                  Status
                </th>
                <th className="pb-3 font-medium text-slate-300 text-sm text-right" data-id="element-1535" data-mp="whoe2mw0mh96">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1536" data-mp="mip1it84q1gw">
              {sortedUsers.map(user => <tr key={user.id} className="border-b border-slate-800 hover:bg-slate-800/50" data-id="element-1537" data-mp="mhntyyqbnx3x">
                  <td className="py-4" data-id="element-1538" data-mp="hknj8aij266h">
                    <div className="flex items-center" data-id="element-1539" data-mp="hloyysahnguj">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-3" data-id="element-1540" data-mp="dj2b12gxug2m">
                        <span className="text-white text-xs font-bold" data-id="element-1541" data-mp="2bvarsliouafh">
                          {user.name.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <div data-id="element-1542" data-mp="3pru503r5z2d4">
                        <div className="text-white font-medium" data-id="element-1543" data-mp="3us82irv52tww">
                          {user.name}
                        </div>
                        <div className="text-slate-400 text-sm" data-id="element-1544" data-mp="3elxifqxlb1z">
                          {user.email}
                        </div>
                        {user.company && <div className="text-slate-500 text-xs" data-id="element-1545" data-mp="36v2epad7fmzk">
                            {user.company}
                          </div>}
                      </div>
                    </div>
                  </td>
                  <td className="py-4" data-id="element-1546" data-mp="3fuz7no6mn80f">
                    <div className="text-white flex items-center" data-id="element-1547" data-mp="3fu5zcis0sag6">
                      <GlobeIcon size={14} className="mr-1 text-slate-400" data-id="element-1548" data-mp="3kvmzgc2ojsvp" />
                      {user.country}
                    </div>
                    <div className="text-slate-400 text-sm flex items-center" data-id="element-1549" data-mp="v7ckdzmq5nek">
                      <MapPinIcon size={12} className="mr-1" data-id="element-1550" data-mp="102rvijtcl57a" />
                      {user.region}
                    </div>
                  </td>
                  <td className="py-4" data-id="element-1551" data-mp="12g2z9zhjokgz">
                    <div className="text-white flex items-center" data-id="element-1552" data-mp="12gw0kkxqihrq">
                      <CalendarIcon size={14} className="mr-1 text-slate-400" data-id="element-1553" data-mp="16hy4vg6idk0k" />
                      {formatDate(user.registrationDate)}
                    </div>
                    <div className="text-slate-400 text-sm flex items-center" data-id="element-1554" data-mp="1beofvp3ghpf4">
                      <ClockIcon size={12} className="mr-1" data-id="element-1555" data-mp="1gfch13lefmn2" />
                      Last: {formatDate(user.lastActive)}
                    </div>
                  </td>
                  <td className="py-4" data-id="element-1556" data-mp="1q5f82y8ymqir">
                    <div className="text-white" data-id="element-1557" data-mp="1q6gvm275x5hd">{user.designs}</div>
                    <div className="text-slate-400 text-sm" data-id="element-1558" data-mp="1u67hpslquxfk">
                      {user.quotes} quotes
                    </div>
                  </td>
                  <td className="py-4 relative" data-id="element-1559" data-mp="1z4iti8vlni0f">
                    <div onClick={() => toggleScoreInfo(user.id)} className="cursor-pointer" data-id="element-1560" data-mp="246hwhhnfgcwu">
                      <LeadScoreBadge score={user.score} data-id="element-1561" data-mp="2eaes2nnsatjg" />
                    </div>
                    {showScoreInfo === user.id && <div className="absolute z-10 mt-2 bg-slate-800 border border-slate-700 rounded-lg shadow-xl p-4 w-72 left-1/2 transform -translate-x-1/2" data-id="element-1562" data-mp="299ine7vlz3cz">
                        <div className="flex justify-between items-start mb-3" data-id="element-1563" data-mp="20a40fienhax8">
                          <h4 className="text-white font-medium" data-id="element-1564" data-mp="2wzv5ucohciht">
                            Score Breakdown
                          </h4>
                          <button className="text-slate-400 hover:text-white" onClick={() => setShowScoreInfo(null)} data-id="element-1565" data-mp="2s1tdf155z6to">
                            <XIcon size={14} data-id="element-1566" data-mp="2n8ifxqm8s2ef" />
                          </button>
                        </div>
                        <div className="space-y-3" data-id="element-1567" data-mp="2j87ztl4qjvlu">
                          <div data-id="element-1568" data-mp="3fqmcv7kzvwt1">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1569" data-mp="3frxdwzn22qgg">
                              <span className="text-slate-300" data-id="element-1570" data-mp="3ayl2jr7e0g5n">Engagement</span>
                              <span className="text-white" data-id="element-1571" data-mp="191kf8m9irbfc">
                                {user.scoreComponents.engagement}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1572" data-mp="zcu52n4bsh59">
                              <div className="bg-blue-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.engagement}%`
                        }} data-id="element-1573" data-mp="14b3yas6hp7o8"></div>
                            </div>
                          </div>
                          <div data-id="element-1574" data-mp="vca3n7cpyrdb">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1575" data-mp="gdg59ojx0c6u">
                              <span className="text-slate-300" data-id="element-1576" data-mp="gfj673mlvpqc">Activity</span>
                              <span className="text-white" data-id="element-1577" data-mp="ld1f4u0mi4yc">
                                {user.scoreComponents.activity}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1578" data-mp="2fp929l6pdhjk">
                              <div className="bg-indigo-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.activity}%`
                        }} data-id="element-1579" data-mp="448kxpkug2bs"></div>
                            </div>
                          </div>
                          <div data-id="element-1580" data-mp="92a5kexx49pd">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1581" data-mp="920bog9r5iee">
                              <span className="text-slate-300" data-id="element-1582" data-mp="mtey6x2vc1q7">
                                Design Quality
                              </span>
                              <span className="text-white" data-id="element-1583" data-mp="irjuxn1dne9s">
                                {user.scoreComponents.designQuality}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1584" data-mp="rtb10sztxn46">
                              <div className="bg-emerald-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.designQuality}%`
                        }} data-id="element-1585" data-mp="2yk0qfw574pzn"></div>
                            </div>
                          </div>
                          <div data-id="element-1586" data-mp="3004uf6nxq00l">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1587" data-mp="2zzd4och0qwi8">
                              <span className="text-slate-300" data-id="element-1588" data-mp="34z7yoow3c27i">
                                Quote Requests
                              </span>
                              <span className="text-white" data-id="element-1589" data-mp="39whx2u1gjo7h">
                                {user.scoreComponents.quoteRequests}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1590" data-mp="2h7ssgl1710qz">
                              <div className="bg-amber-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.quoteRequests}%`
                        }} data-id="element-1591" data-mp="2m7f8f28eov3h"></div>
                            </div>
                          </div>
                          <div data-id="element-1592" data-mp="1yivuo76l7q40">
                            <div className="flex justify-between text-sm mb-1" data-id="element-1593" data-mp="1yhul6757zboe">
                              <span className="text-slate-300" data-id="element-1594" data-mp="fn9kzsw760a0">
                                Market Potential
                              </span>
                              <span className="text-white" data-id="element-1595" data-mp="bkv4vgjwxemf">
                                {user.scoreComponents.marketPotential}
                              </span>
                            </div>
                            <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1596" data-mp="1qw1yfc0lqtf">
                              <div className="bg-purple-500 h-1.5 rounded-full" style={{
                          width: `${user.scoreComponents.marketPotential}%`
                        }} data-id="element-1597" data-mp="3swxih3er1cmg"></div>
                            </div>
                          </div>
                          <div className="pt-2 border-t border-slate-700" data-id="element-1598" data-mp="3f4hb5qetesfq">
                            <div className="flex justify-between font-medium" data-id="element-1599" data-mp="3a4uz3kaq3i8i">
                              <span className="text-blue-300" data-id="element-1600" data-mp="3558jx5bc3rx2">Total Score</span>
                              <span className="text-white" data-id="element-1601" data-mp="357bkgja453g1">{user.score}</span>
                            </div>
                          </div>
                        </div>
                      </div>}
                  </td>
                  <td className="py-4" data-id="element-1602" data-mp="2mgy57bh2sodb">
                    {renderLeadStatusBadge(user.leadStatus)}
                  </td>
                  <td className="py-4 text-right" data-id="element-1603" data-mp="2qhrr5zayjt3k">
                    <div className="flex justify-end space-x-2" data-id="element-1604" data-mp="2qkmbzrxvvfxi">
                      <button className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 hover:bg-blue-500/30" title="Assign to Dealer" data-id="element-1605" data-mp="3e9fbfydps5wv">
                        <UserCheckIcon size={16} data-id="element-1606" data-mp="3j9bdhs2upn9s" />
                      </button>
                      <button className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 hover:bg-blue-500/30" title="Contact User" data-id="element-1607" data-mp="35fanbmpyt8l1">
                        <MailIcon size={16} data-id="element-1608" data-mp="11lzo4e9cppk" />
                      </button>
                      <button className="p-1.5 rounded-lg bg-blue-500/20 text-blue-400 hover:bg-blue-500/30" title="View Details" onClick={() => handleViewDetails(user)} data-id="element-1609" data-mp="10atjxxcb5va">
                        <EyeIcon size={16} data-id="element-1610" data-mp="1qhetpsxbz51w" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {sortedUsers.length === 0 && <div className="text-center py-12 text-slate-400" data-id="element-1611" data-mp="207zpz9pj7xhn">
              No users found matching your search criteria
            </div>}
        </div>
      </DashboardCard>
      {/* User Details Modal */}
      {showUserDetails && selectedUser && <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" data-id="element-1612" data-mp="12kscwx3id23t">
          <div className="bg-gradient-to-br from-slate-900 to-blue-900 rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-auto" data-id="element-1613" data-mp="12n4zxoo4i2nq">
            <div className="p-6 border-b border-slate-700 flex justify-between items-start sticky top-0 bg-gradient-to-r from-slate-900 to-blue-900 z-10" data-id="element-1614" data-mp="1chx0n1d055mq">
              <div className="flex items-center" data-id="element-1615" data-mp="2sz1azrfwon93">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-4" data-id="element-1616" data-mp="2nx28ejrzpud7">
                  <span className="text-white text-lg font-bold" data-id="element-1617" data-mp="l9lofm0vhrar">
                    {selectedUser.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div data-id="element-1618" data-mp="v7jca8etlm2u">
                  <h2 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-1619" data-mp="100cil0pxt2h1">
                    {selectedUser.name}
                    <LeadScoreBadge score={selectedUser.score} data-id="element-1620" data-mp="15075yuai79xc" />
                    {renderLeadStatusBadge(selectedUser.leadStatus)}
                  </h2>
                  <div className="text-slate-300 flex items-center" data-id="element-1621" data-mp="192vhj9qlquy0">
                    <MailIcon size={14} className="mr-1 text-slate-400" data-id="element-1622" data-mp="1e0na85z2ml39" />
                    {selectedUser.email}
                  </div>
                  {selectedUser.company && <div className="text-slate-400 text-sm mt-1" data-id="element-1623" data-mp="3fs0aghq3g4sz">
                      {selectedUser.company}
                    </div>}
                </div>
              </div>
              <button onClick={handleCloseDetails} className="p-2 rounded-full bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-white transition-colors" data-id="element-1624" data-mp="3d72e1836iwqd">
                <XIcon size={20} data-id="element-1625" data-mp="38era7u5biqsj" />
              </button>
            </div>
            {/* ... resto del contenido del modal ... */}
            <div className="p-6" data-id="element-1626" data-mp="2yi67xgkontse">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1627" data-mp="2yixuk1wayh6j">
                {/* User Activity Section - Moved to the top */}
                <div className="space-y-6 md:col-span-2" data-id="element-1628" data-mp="3w556jwuxrbsx">
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1629" data-mp="3r6k7i0rf6y62">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1630" data-mp="3m77hj7595az9">
                      <ActivityIcon size={18} className="mr-2 text-blue-400" data-id="element-1631" data-mp="3h95q9yxoa5cp" />
                      User Activity
                    </h3>
                    {/* Activity Timeline */}
                    <div className="mb-6" data-id="element-1632" data-mp="25th3p8obz8cf">
                      <h4 className="text-white font-medium mb-3" data-id="element-1633" data-mp="25spj0sw9uv0x">
                        Recent Activity History
                      </h4>
                      <div className="space-y-4" data-id="element-1634" data-mp="13zi1g20dygq1">
                        <div className="flex" data-id="element-1635" data-mp="z3sz5qwzelq1">
                          <div className="mr-3 relative" data-id="element-1636" data-mp="z0x204syk12n">
                            <div className="w-8 h-8 rounded-full bg-blue-500/30 flex items-center justify-center" data-id="element-1637" data-mp="1dsfp0mk8ivvi">
                              <MousePointerIcon size={14} className="text-blue-300" data-id="element-1638" data-mp="18zmjvxkutliw" />
                            </div>
                            <div className="absolute top-8 bottom-0 left-1/2 w-0.5 bg-blue-500/20" data-id="element-1639" data-mp="1mu5g1ra7fssr"></div>
                          </div>
                          <div className="flex-1 pb-4" data-id="element-1640" data-mp="1wqs04dupiftq">
                            <div className="flex justify-between" data-id="element-1641" data-mp="1wofhrzl1e3g5">
                              <div className="text-white font-medium" data-id="element-1642" data-mp="1rsqgnrtdcehq">
                                Design Session
                              </div>
                              <div className="text-slate-400 text-sm" data-id="element-1643" data-mp="3tj1w37dkpxcj">
                                Today, 10:45 AM
                              </div>
                            </div>
                            <div className="text-slate-300 text-sm" data-id="element-1644" data-mp="2dzukp6zg0rmi">
                              Created a new center pivot system design
                            </div>
                            <div className="text-slate-400 text-xs mt-1" data-id="element-1645" data-mp="1zaoe2xy9zz4l">
                              Duration: 32 minutes
                            </div>
                          </div>
                        </div>
                        <div className="flex" data-id="element-1646" data-mp="1qcmfep20likh">
                          <div className="mr-3 relative" data-id="element-1647" data-mp="1ucwj1v2c3ww6">
                            <div className="w-8 h-8 rounded-full bg-emerald-500/30 flex items-center justify-center" data-id="element-1648" data-mp="1gc2btfr0w1z3">
                              <FileTextIcon size={14} className="text-emerald-300" data-id="element-1649" data-mp="1lancfga6sno2" />
                            </div>
                            <div className="absolute top-8 bottom-0 left-1/2 w-0.5 bg-blue-500/20" data-id="element-1650" data-mp="3ar4xf2cyazwq"></div>
                          </div>
                          <div className="flex-1 pb-4" data-id="element-1651" data-mp="3fn3q325bb42y">
                            <div className="flex justify-between" data-id="element-1652" data-mp="3e8aphqc3wzsl">
                              <div className="text-white font-medium" data-id="element-1653" data-mp="398xx6q2gv0im">
                                Requested Quote
                              </div>
                              <div className="text-slate-400 text-sm" data-id="element-1654" data-mp="34ad3l9hpzf35">
                                Yesterday, 15:30 PM
                              </div>
                            </div>
                            <div className="text-slate-300 text-sm" data-id="element-1655" data-mp="rtciaas2f9x">
                              Requested a quote for an 8-tower system
                            </div>
                            <div className="text-slate-400 text-xs mt-1" data-id="element-1656" data-mp="3n7xj3pylh1b3">
                              Quote ID: Q-2025-0734
                            </div>
                          </div>
                        </div>
                        <div className="flex" data-id="element-1657" data-mp="jke0pefj7w7e">
                          <div className="mr-3 relative" data-id="element-1658" data-mp="esvyyo5oprld">
                            <div className="w-8 h-8 rounded-full bg-amber-500/30 flex items-center justify-center" data-id="element-1659" data-mp="erchwvc7fcij">
                              <ExternalLinkIcon size={14} className="text-amber-300" data-id="element-1660" data-mp="n3cv55i9pu5g" />
                            </div>
                          </div>
                          <div className="flex-1" data-id="element-1661" data-mp="w1yj5g6ie1dm">
                            <div className="flex justify-between" data-id="element-1662" data-mp="w4b0br4g07pm">
                              <div className="text-white font-medium" data-id="element-1663" data-mp="11244kem6qrn9">
                                Visited Product Gallery
                              </div>
                              <div className="text-slate-400 text-sm" data-id="element-1664" data-mp="1a1r7j4ukc5if">
                                3 days ago
                              </div>
                            </div>
                            <div className="text-slate-300 text-sm" data-id="element-1665" data-mp="1jrsutuf3djwa">
                              Reviewed pivot irrigation system specifications
                            </div>
                            <div className="text-slate-400 text-xs mt-1" data-id="element-1666" data-mp="1oosqdbebf495">
                              Duration: 18 minutes
                            </div>
                          </div>
                        </div>
                      </div>
                      <button className="mt-3 text-blue-400 hover:text-blue-300 text-sm flex items-center" data-id="element-1667" data-mp="2lj27b4wigtxj">
                        View complete history
                        <ChevronRightIcon size={14} className="ml-1" data-id="element-1668" data-mp="3099dom98umhv" />
                      </button>
                    </div>
                    {/* Activity Metrics */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5" data-id="element-1669" data-mp="27jap0ryyordq">
                      <div className="bg-blue-900/30 p-3 rounded-lg text-center" data-id="element-1670" data-mp="22kg5tox310t3">
                        <div className="text-2xl font-bold text-white" data-id="element-1671" data-mp="2gjpabrbxe6h8">
                          {selectedUser.usageStats.lastWeek}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-1672" data-mp="2cjot5yxfzh6h">
                          Sessions last 7 days
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-3 rounded-lg text-center" data-id="element-1673" data-mp="3nvzitwgw2x6p">
                        <div className="text-2xl font-bold text-white" data-id="element-1674" data-mp="3vf8opfq6sdr0">
                          {selectedUser.usageStats.lastMonth}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-1675" data-mp="3li43bi460mb9">
                          Sessions last 30 days
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-3 rounded-lg text-center" data-id="element-1676" data-mp="3qhfkgs8g1ttd">
                        <div className="text-2xl font-bold text-white" data-id="element-1677" data-mp="i1vvw6ipwzkn">
                          {selectedUser.usageStats.total}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-1678" data-mp="8c3xf17hzmaw">
                          Total sessions
                        </div>
                      </div>
                    </div>
                    {/* Weekly Usage Pattern */}
                    <div className="mb-5" data-id="element-1679" data-mp="10zgbso3i8nt4">
                      <div className="text-white font-medium mb-3" data-id="element-1680" data-mp="15qybz9xpekd1">
                        Weekly Usage Pattern
                      </div>
                      <div className="flex justify-between bg-slate-800/70 p-3 rounded-lg" data-id="element-1681" data-mp="1flvsbmb4pu3b">
                        {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((day, index) => <div key={index} className="text-center" data-id="element-1682" data-mp="1am12lm33baju" data-mpi={index}>
                              <div className="text-xs text-slate-400 mb-1" data-id="element-1683" data-mp="16kpa98su0b7y">
                                {day}
                              </div>
                              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${selectedUser.usageDays[index] ? 'bg-blue-500/30 text-blue-300' : 'bg-slate-700/30 text-slate-500'}`} data-id="element-1684" data-mp="wom6xzm8u6jf">
                                {selectedUser.usageDays[index] ? <CheckIcon size={12} data-id="element-1685" data-mp="mysvqzq0jtfp" /> : '-'}
                              </div>
                            </div>)}
                      </div>
                      <div className="text-xs text-slate-400 mt-2" data-id="element-1686" data-mp="dxbhzo02w3u6">
                        User shows higher activity during weekdays, with peaks
                        on Mondays and Thursdays.
                      </div>
                    </div>
                    {/* Score Breakdown - UPDATED */}
                    <div className="space-y-4" data-id="element-1687" data-mp="2pkf110wgd0mi">
                      <h4 className="text-white font-medium mb-2" data-id="element-1688" data-mp="2pj3ly4xk46g3">
                        Score Breakdown
                      </h4>
                      <div className="space-y-5" data-id="element-1689" data-mp="2ylmkicub7wwj">
                        {/* App Activity */}
                        <div data-id="element-1690" data-mp="21vcb75ro01gx">
                          <div className="flex justify-between mb-1" data-id="element-1691" data-mp="21w59dick5ing">
                            <div className="text-slate-300 flex items-center" data-id="element-1692" data-mp="26ugjzvaofx6q">
                              <ActivityIcon size={14} className="mr-1 text-blue-400" data-id="element-1693" data-mp="26scdd5le8k2r" />
                              App Activity
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('activity')} data-id="element-1694" data-mp="2fmij9q90f7ff">
                                <HelpCircleIcon size={14} data-id="element-1695" data-mp="1j4cqigr7ddtg" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1696" data-mp="1n43ekcpchfua">
                              {selectedUser.scoreComponents.engagement}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1697" data-mp="qhbfbm3rjzqi">
                            <div className="bg-blue-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.engagement}%`
                        }} data-id="element-1698" data-mp="qeyoskjxwh1u"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1699" data-mp="ujg529r3cc7v">
                            Evaluates the frequency and depth of system usage.
                          </div>
                          {showLongDescription === 'activity' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1700" data-mp="149r9ryilmpft">
                              Includes how many times they've logged in, how
                              many designs they've created, and whether they've
                              interacted with key features like quotes or
                              orders.
                            </div>}
                        </div>
                        {/* Time on Platform */}
                        <div data-id="element-1701" data-mp="1nv19hzs3rman">
                          <div className="flex justify-between mb-1" data-id="element-1702" data-mp="1ntq7o5i7wom6">
                            <div className="text-slate-300 flex items-center" data-id="element-1703" data-mp="1sstbxnqdiqt3">
                              <TimerIcon size={14} className="mr-1 text-indigo-400" data-id="element-1704" data-mp="1e4yiu68gekfh" />
                              Time on Platform
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('time')} data-id="element-1705" data-mp="1iwgh2mj3e6wr">
                                <HelpCircleIcon size={14} data-id="element-1706" data-mp="151xdi7rewxcv" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1707" data-mp="v644gycwjlzu">
                              {selectedUser.scoreComponents.activity}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1708" data-mp="z90c5lgtab4u">
                            <div className="bg-indigo-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.activity}%`
                        }} data-id="element-1709" data-mp="13avfeviayyl9"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1710" data-mp="ubhzpl3l5ds3">
                            Measures how long they've been active since
                            registration.
                          </div>
                          {showLongDescription === 'time' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1711" data-mp="1n0xdgimmxkrp">
                              A lead with several weeks or months of consistent
                              activity is considered more engaged than one who
                              just registered.
                            </div>}
                        </div>
                        {/* Geographic Location */}
                        <div data-id="element-1712" data-mp="3qfr651muj0qh">
                          <div className="flex justify-between mb-1" data-id="element-1713" data-mp="3qepxf3tayqbx">
                            <div className="text-slate-300 flex items-center" data-id="element-1714" data-mp="3lhfymxk0x2bf">
                              <MapPinIcon size={14} className="mr-1 text-emerald-400" data-id="element-1715" data-mp="32x97ffrxgq9" />
                              Geographic Location
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('location')} data-id="element-1716" data-mp="3v7sggi0gehdv">
                                <HelpCircleIcon size={14} data-id="element-1717" data-mp="37j9awa8sgiph" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1718" data-mp="3ghl50m8v5ymo">
                              {selectedUser.scoreComponents.designQuality}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1719" data-mp="vqt5ij1fl6mi">
                            <div className="bg-emerald-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.designQuality}%`
                        }} data-id="element-1720" data-mp="qt114pjlns1f"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1721" data-mp="3pi97p52xk6io">
                            Considers the user's country or region based on
                            sales potential.
                          </div>
                          {showLongDescription === 'location' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1722" data-mp="31u9lmigkd4af">
                              Some regions have higher purchase history or
                              active commercial strategies.
                            </div>}
                        </div>
                        {/* Market Potential */}
                        <div data-id="element-1723" data-mp="3fmzaqvre2pbr">
                          <div className="flex justify-between mb-1" data-id="element-1724" data-mp="2i60hda1qx7uk">
                            <div className="text-slate-300 flex items-center" data-id="element-1725" data-mp="2i5qqlk8vmwnt">
                              <GlobeIcon size={14} className="mr-1 text-purple-400" data-id="element-1726" data-mp="2n3sk6z3xiedj" />
                              Market Potential
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('market')} data-id="element-1727" data-mp="2fjhw8rf77b20">
                                <HelpCircleIcon size={14} data-id="element-1728" data-mp="25mvc64up4o11" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1729" data-mp="21l9um677vlki">
                              {selectedUser.scoreComponents.marketPotential}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1730" data-mp="1ruozwtunz16v">
                            <div className="bg-purple-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.marketPotential}%`
                        }} data-id="element-1731" data-mp="1mxgcadqqy4y8"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1732" data-mp="18x5ndg8zz0fp">
                            Evaluation of the commercial value of the region or
                            country where the lead is located.
                          </div>
                          {showLongDescription === 'market' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1733" data-mp="3d335pose22ky">
                              Market potential represents the strategic
                              opportunity to generate sales in the lead's
                              geographic area. This assessment is based on
                              factors such as local agricultural investment,
                              irrigation technology adoption, subsidy presence,
                              regional sales history, and competition in the
                              area. Higher market potential indicates a higher
                              probability of conversion and greater long-term
                              value for the company.
                            </div>}
                        </div>
                        {/* Quote Requests */}
                        <div data-id="element-1734" data-mp="tmwaop6q050i">
                          <div className="flex justify-between mb-1" data-id="element-1735" data-mp="tk0cczqynebj">
                            <div className="text-slate-300 flex items-center" data-id="element-1736" data-mp="oouuqd4lclt9">
                              <ClipboardIcon size={14} className="mr-1 text-amber-400" data-id="element-1737" data-mp="12fq37ob6h0wb" />
                              Quote Requests
                              <button className="ml-1 text-slate-400 hover:text-blue-400" onClick={() => toggleLongDescription('quotes')} data-id="element-1738" data-mp="xlvcw212hno9">
                                <HelpCircleIcon size={14} data-id="element-1739" data-mp="17eatow0mo67k" />
                              </button>
                            </div>
                            <div className="text-white font-medium" data-id="element-1740" data-mp="1lc98u3mrw6o4">
                              {selectedUser.scoreComponents.quoteRequests}/100
                            </div>
                          </div>
                          <div className="w-full bg-slate-700/50 rounded-full h-2 mb-1" data-id="element-1741" data-mp="3n5fg3vsbmcmd">
                            <div className="bg-amber-500 h-2 rounded-full" style={{
                          width: `${selectedUser.scoreComponents.quoteRequests}%`
                        }} data-id="element-1742" data-mp="3j4n5oz7pq1oi"></div>
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-1743" data-mp="1r3lwcr1s1o8q">
                            Request sent by a public user interested in
                            obtaining prices.
                          </div>
                          {showLongDescription === 'quotes' && <div className="mt-2 p-3 bg-slate-700/50 rounded-lg text-xs text-slate-300" data-id="element-1744" data-mp="250imsrdzh3p3">
                              This is a formal request made through the platform
                              by a public user—i.e., not yet assigned to any
                              dealer or classified as a customer—who has
                              designed a system or project and wants to receive
                              a quote. This type of interaction represents a
                              clear purchase intention and constitutes a
                              valuable commercial lead. It can be the starting
                              point for contacting, qualifying, and converting
                              the user into a customer, either by assigning them
                              to a dealer or managing them directly from a
                              Business Unit.
                            </div>}
                        </div>
                        <div className="pt-4 border-t border-slate-700 flex items-center justify-between" data-id="element-1745" data-mp="10s1nldxts9qb">
                          <div className="text-lg text-blue-300 font-medium flex items-center" data-id="element-1746" data-mp="vtqdd23mbx7k">
                            <PieChartIcon size={18} className="mr-2" data-id="element-1747" data-mp="r0x9egfz4swj" />
                            Total Score
                          </div>
                          <div className="text-2xl font-bold text-white" data-id="element-1748" data-mp="m0rqppromgql">
                            {selectedUser.score}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ... resto de las secciones del modal ... */}
                {/* User Information - Moved down */}
                <div className="space-y-6" data-id="element-1749" data-mp="rwrp5ie86mqg">
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1750" data-mp="e3tn5d7a1wdx">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1751" data-mp="i4dlgk3l761n">
                      <UserIcon size={18} className="mr-2 text-blue-400" data-id="element-1752" data-mp="15uprtqj6ouq4" />
                      User Information
                    </h3>
                    <div className="space-y-4" data-id="element-1753" data-mp="1as9hrnp8uvxw">
                      <div className="flex justify-between" data-id="element-1754" data-mp="wtrv7tb2rphk">
                        <div className="text-slate-400" data-id="element-1755" data-mp="wt9pm62ivywz">Email</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1756" data-mp="11s35g55a820b">
                          <MailIcon size={14} className="mr-1 text-blue-400" data-id="element-1757" data-mp="3hjhag7foxdas" />
                          {selectedUser.email}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1758" data-mp="3e230te9gvjxe">
                        <div className="text-slate-400" data-id="element-1759" data-mp="3e0i69on5k0zj">Phone</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1760" data-mp="3a19ayfcgrv1v">
                          <PhoneIcon size={14} className="mr-1 text-blue-400" data-id="element-1761" data-mp="3o00r07avzqsn" />
                          {selectedUser.phone}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1762" data-mp="2vblathg0r2fq">
                        <div className="text-slate-400" data-id="element-1763" data-mp="2vc4r6tq0tirn">Registration Date</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1764" data-mp="2qdjrcveol13q">
                          <CalendarIcon size={14} className="mr-1 text-blue-400" data-id="element-1765" data-mp="351odk9cxzur9" />
                          {formatDate(selectedUser.registrationDate)}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1766" data-mp="2ck287bpwpqe8">
                        <div className="text-slate-400" data-id="element-1767" data-mp="27m0oqpokjp28">Country & Region</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1768" data-mp="27jwpwm5j1g8t">
                          <GlobeIcon size={14} className="mr-1 text-blue-400" data-id="element-1769" data-mp="15nl08mt21m1z" />
                          {selectedUser.country} ({selectedUser.region})
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1770" data-mp="vwglno7ak37o">
                        <div className="text-slate-400" data-id="element-1771" data-mp="qy5935pm3elr">Designs Created</div>
                        <div className="text-white font-medium" data-id="element-1772" data-mp="1okm7kea2zy93">
                          {selectedUser.designs}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1773" data-mp="1jjyeln2al7c8">
                        <div className="text-slate-400" data-id="element-1774" data-mp="1eldc1gzkibkm">Last Activity</div>
                        <div className="text-white font-medium flex items-center" data-id="element-1775" data-mp="1alut2qrb4akf">
                          <ClockIcon size={14} className="mr-1 text-blue-400" data-id="element-1776" data-mp="379n4p7u7dmf" />
                          {formatDate(selectedUser.lastActive)}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1777" data-mp="2atjgp4b4enjr">
                        <div className="text-slate-400" data-id="element-1778" data-mp="2av47ciubdmcc">Usage Frequency</div>
                        <div className="text-white font-medium" data-id="element-1779" data-mp="2evo8dxi0da3r">
                          {selectedUser.usageFrequency}
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-1780" data-mp="2okxwz3dn8an4">
                        <div className="text-slate-400" data-id="element-1781" data-mp="2omiriszyjtkz">Lead Score</div>
                        <LeadScoreBadge score={selectedUser.score} data-id="element-1782" data-mp="2tjhnlh36malt" />
                      </div>
                      <div className="flex justify-between" data-id="element-1783" data-mp="2yhau6b8ed6mm">
                        <div className="text-slate-400" data-id="element-1784" data-mp="32k7eq7hhzct7">Lead Status</div>
                        <div className="text-white font-medium" data-id="element-1785" data-mp="37jjyukgzi5s3">
                          {renderLeadStatusBadge(selectedUser.leadStatus)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Actions Panel */}
                <div className="space-y-6" data-id="element-1786" data-mp="2gg5awn8o0pr9">
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1787" data-mp="2gh81eu22sq6n">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1788" data-mp="2binbbngjfmvx">
                      <CheckCircleIcon size={18} className="mr-2 text-blue-400" data-id="element-1789" data-mp="2pi65fccikxp8" />
                      Lead Qualification
                    </h3>
                    <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1790" data-mp="2kkd1kpyoofs4">
                      <button onClick={() => handleQualifyLead('qualified')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'qualified' ? 'bg-red-600/40 text-red-300 cursor-not-allowed' : 'bg-red-600/20 hover:bg-red-600/30 text-red-400'}`} disabled={selectedUser.leadStatus === 'qualified'} onMouseEnter={() => setTooltipVisible('hot-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1791" data-mp="2zdzpdgskbth1">
                        <div size={16} className="mr-2" data-id="element-1792" data-mp="3d6xp1fc1g7qe" />
                        {selectedUser.leadStatus === 'qualified' ? 'Hot lead' : 'Mark as Hot'}
                        {tooltipVisible === 'hot-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1793" data-mp="5m69swyghqub">
                            Ready to purchase
                          </div>}
                      </button>
                      <button onClick={() => handleQualifyLead('new')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'new' ? 'bg-amber-600/40 text-amber-300 cursor-not-allowed' : 'bg-amber-600/20 hover:bg-amber-600/30 text-amber-400'}`} disabled={selectedUser.leadStatus === 'new'} onMouseEnter={() => setTooltipVisible('warm-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1794" data-mp="3rvh9gvhkad0v">
                        <ThermometerIcon size={16} className="mr-2" data-id="element-1795" data-mp="2v46pqg5mz4h5" />
                        {selectedUser.leadStatus === 'new' ? 'Warm lead' : 'Mark as Warm'}
                        {tooltipVisible === 'warm-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1796" data-mp="2s1shqnz34z6n">
                            Interested, needs follow-up
                          </div>}
                      </button>
                      <button onClick={() => handleQualifyLead('disqualified')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'disqualified' ? 'bg-blue-600/40 text-blue-300 cursor-not-allowed' : 'bg-blue-600/20 hover:bg-blue-600/30 text-blue-400'}`} disabled={selectedUser.leadStatus === 'disqualified'} onMouseEnter={() => setTooltipVisible('cold-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1797" data-mp="2dd602flzjvc9">
                        <SnowflakeIcon size={16} className="mr-2" data-id="element-1798" data-mp="3tqw6vu4hoxpl" />
                        {selectedUser.leadStatus === 'disqualified' ? 'Cold lead' : 'Mark as Cold'}
                        {tooltipVisible === 'cold-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1799" data-mp="13e9sc7omeft">
                            Low activity or intention
                          </div>}
                      </button>
                      <button onClick={() => handleQualifyLead('unclassified')} className={`py-3 rounded-lg flex items-center justify-center transition-colors relative ${selectedUser.leadStatus === 'unclassified' ? 'bg-slate-600/40 text-slate-300 cursor-not-allowed' : 'bg-slate-600/20 hover:bg-slate-600/30 text-slate-400'}`} disabled={selectedUser.leadStatus === 'unclassified'} onMouseEnter={() => setTooltipVisible('unclassified-btn')} onMouseLeave={() => setTooltipVisible(null)} data-id="element-1800" data-mp="9y2gm6swo46q">
                        <BanIcon size={16} className="mr-2" data-id="element-1801" data-mp="3s7mi3gk5n7yq" />
                        {selectedUser.leadStatus === 'unclassified' ? 'Unclassified' : 'Unclassify'}
                        {tooltipVisible === 'unclassified-btn' && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded whitespace-nowrap" data-id="element-1802" data-mp="17lb76g7rk3fl">
                            Remove lead classification
                          </div>}
                      </button>
                    </div>
                    <div className="space-y-2 mt-4" data-id="element-1803" data-mp="mufnbg3lxuy3">
                      <div className="text-slate-400 text-sm mb-2" data-id="element-1804" data-mp="muywo8f6zb0i">Tags:</div>
                      {selectedUser.tags.map((tag, index) => <div key={index} className="inline-flex items-center bg-blue-900/30 text-blue-300 px-2 py-1 rounded-md text-xs mr-2" data-id="element-1805" data-mp="3v84s4qtst34b" data-mpi={index}>
                          <TagIcon size={12} className="mr-1" data-id="element-1806" data-mp="8v6amqem1iyv" />
                          {tag}
                        </div>)}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1807" data-mp="423fwey3k3h3">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1808" data-mp="3cheov10bfeax">
                      <ArrowRightIcon size={18} className="mr-2 text-blue-400" data-id="element-1809" data-mp="37ik6g069frrc" />
                      Suggested Actions
                    </h3>
                    <div className="space-y-4" data-id="element-1810" data-mp="1rtm0zmnwoo3m">
                      <div className="bg-blue-900/30 p-4 rounded-lg hover:bg-blue-800/30 transition-colors cursor-pointer" data-id="element-1811" data-mp="1rvf9l7i2xie9">
                        <div className="flex items-start" data-id="element-1812" data-mp="1i3j0l1egg7v9">
                          <div className="p-2 rounded-lg bg-blue-500/20 mr-3" data-id="element-1813" data-mp="1i42em70zic40">
                            <UserCheckIcon size={16} className="text-blue-400" data-id="element-1814" data-mp="25u53ke9lr1ye" />
                          </div>
                          <div className="flex-1" data-id="element-1815" data-mp="2arojdily7msg">
                            <h4 className="text-white font-medium" data-id="element-1816" data-mp="1wsp6173vyubl">
                              Assign to Distributor
                            </h4>
                            <p className="text-slate-400 text-sm mt-1" data-id="element-1817" data-mp="20sfwf9pi38fl">
                              Connect this lead with the appropriate distributor
                              in their region
                            </p>
                          </div>
                          <ChevronRightIcon size={16} className="text-slate-400" data-id="element-1818" data-mp="1h2ouapbwqcrx" />
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-4 rounded-lg hover:bg-blue-800/30 transition-colors cursor-pointer" data-id="element-1819" data-mp="1c20rz7i8a9ie">
                        <div className="flex items-start" data-id="element-1820" data-mp="183l83chg1h97">
                          <div className="p-2 rounded-lg bg-emerald-500/20 mr-3" data-id="element-1821" data-mp="133ytozpvpuyt">
                            <MailIcon size={16} className="text-emerald-400" data-id="element-1822" data-mp="1zrv39kmwfq0j" />
                          </div>
                          <div className="flex-1" data-id="element-1823" data-mp="1vsmbglbf627m">
                            <h4 className="text-white font-medium" data-id="element-1824" data-mp="1r0mg766anxhd">
                              Contact by Email
                            </h4>
                            <p className="text-slate-400 text-sm mt-1" data-id="element-1825" data-mp="1m0qdda9c2c3e">
                              Send a personalized email to interact with this
                              lead
                            </p>
                          </div>
                          <ChevronRightIcon size={16} className="text-slate-400" data-id="element-1826" data-mp="2m1bo39mzw7gs" />
                        </div>
                      </div>
                      <div className="bg-blue-900/30 p-4 rounded-lg hover:bg-blue-800/30 transition-colors cursor-pointer" data-id="element-1827" data-mp="2r1hhau8wy20z">
                        <div className="flex items-start" data-id="element-1828" data-mp="2vy7xriomqzmx">
                          <div className="p-2 rounded-lg bg-amber-500/20 mr-3" data-id="element-1829" data-mp="301czvk4sszb1">
                            <UserPlusIcon size={16} className="text-amber-400" data-id="element-1830" data-mp="350h6c30c8ixo" />
                          </div>
                          <div className="flex-1" data-id="element-1831" data-mp="39yr14ci5hhir">
                            <h4 className="text-white font-medium" data-id="element-1832" data-mp="39xfxccopg9rn">
                              Convert to Customer
                            </h4>
                            <p className="text-slate-400 text-sm mt-1" data-id="element-1833" data-mp="3jpdd7wqnrpwp">
                              Update this lead to customer status
                            </p>
                          </div>
                          <ChevronRightIcon size={16} className="text-slate-400" data-id="element-1834" data-mp="3sp0gyp6v17sx" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700" data-id="element-1835" data-mp="2ptvhn8b6kv8a">
                    <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-1836" data-mp="2tw8c30kh96pr">
                      <FileTextIcon size={18} className="mr-2 text-blue-400" data-id="element-1837" data-mp="2yv30qj54lphs" />
                      Notes
                    </h3>
                    <div className="bg-slate-900/50 p-3 rounded-lg text-slate-300 text-sm mb-4" data-id="element-1838" data-mp="225lrju6xplbc">
                      {selectedUser.notes || 'No notes available for this lead.'}
                    </div>
                    <div className="flex" data-id="element-1839" data-mp="2b4fsfwrasxup">
                      <input type="text" placeholder="Add a note..." className="flex-1 bg-slate-800 border border-slate-700 rounded-l-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1840" data-mp="2b3nwulxpb04f" />
                      <button className="bg-blue-600 text-white px-4 py-2 rounded-r-lg hover:bg-blue-700 transition-colors" data-id="element-1841" data-mp="1nfwjrg4c6j23">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-slate-700 flex justify-between sticky bottom-0 bg-gradient-to-r from-slate-900 to-blue-900" data-id="element-1842" data-mp="1avhitsdwp353">
              <button onClick={handleCloseDetails} className="px-4 py-2 bg-slate-800 text-slate-300 rounded-lg hover:bg-slate-700 transition-colors" data-id="element-1843" data-mp="11xdu6n7mjq92">
                Close
              </button>
              <div className="flex space-x-3" data-id="element-1844" data-mp="s6j75gmk0mmk">
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center" data-id="element-1845" data-mp="s4pyxwwalucg">
                  <PencilIcon size={16} className="mr-2" data-id="element-1846" data-mp="i8wn6fqee4vq" />
                  Edit User
                </button>
                <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors flex items-center" data-id="element-1847" data-mp="e7b6ejaqt6g9">
                  <StarIcon size={16} className="mr-2" data-id="element-1848" data-mp="98qfjahdrz4h" />
                  Mark as Priority
                </button>
              </div>
            </div>
          </div>
        </div>}
    </>;
}